import { Subject } from 'rxjs';

import { AnswerEngineTypesEnum } from '../enums/answer-engine-types.enum';
import { ViAnswerEngineSource } from './vi-answer-engine-source.model';

export interface AnswerEngineOption {
    type: AnswerEngineTypesEnum;
    label: string;
    logoUrl: string;
    labelIconUrl: string;
    linkUrl: string;

    loading?: boolean;
    answerText?: string;
    sources?: ViAnswerEngineSource[];
    rawResponse?: any;
    destroyApiCall$?: Subject<void>;
};


export const getAllEngineOptions = (): AnswerEngineOption[]  => {
    return [
        chatGptEngineOption,
        geminiEngineOption,
        perplexityEngineOption,
        claudeEngineOption,
        grokEngineOption
    ];
};

export const chatGptEngineOption: AnswerEngineOption = {
    type: AnswerEngineTypesEnum.CHATGPT,
    label: `Vi.answerEngineType.${AnswerEngineTypesEnum.CHATGPT}`,
    logoUrl: 'assets/images/aiModel_logo_openai.png',
    labelIconUrl: 'assets/images/aiModel_textIcon_openai.png',
    linkUrl: 'https://chatgpt.com',
    destroyApiCall$: new Subject<void>(),
    loading: true
};

export const geminiEngineOption: AnswerEngineOption = {
    type: AnswerEngineTypesEnum.GEMINI,
    label: `Vi.answerEngineType.${AnswerEngineTypesEnum.GEMINI}`,
    logoUrl: 'assets/images/aiModel_logo_gemini.png',
    labelIconUrl: 'assets/images/aiModel_textIcon_gemini.png',
    linkUrl: 'https://gemini.google.com/app',
    destroyApiCall$: new Subject<void>(),
    loading: true
};

export const perplexityEngineOption: AnswerEngineOption = {
    type: AnswerEngineTypesEnum.PERPLEXITY,
    label: `Vi.answerEngineType.${AnswerEngineTypesEnum.PERPLEXITY}`,
    logoUrl: 'assets/images/aiModel_logo_perplexity.png',
    labelIconUrl: 'assets/images/aiModel_textIcon_perplexity.png',
    linkUrl: 'https://www.perplexity.ai',
    destroyApiCall$: new Subject<void>(),
    loading: true
};

export const claudeEngineOption: AnswerEngineOption = {
    type: AnswerEngineTypesEnum.CLAUDE,
    label: `Vi.answerEngineType.${AnswerEngineTypesEnum.CLAUDE}`,
    logoUrl: 'assets/images/aiModel_logo_claude.png',
    labelIconUrl: 'assets/images/aiModel_textIcon_claude.png',
    linkUrl: 'https://claude.ai',
    destroyApiCall$: new Subject<void>(),
    loading: true
};

export const grokEngineOption: AnswerEngineOption = {
    type: AnswerEngineTypesEnum.GROK,
    label: `Vi.answerEngineType.${AnswerEngineTypesEnum.GROK}`,
    logoUrl: 'assets/images/aiModel_logo_grok.png',
    labelIconUrl: 'assets/images/aiModel_textIcon_grok.png',
    linkUrl: 'https://grok.com',
    destroyApiCall$: new Subject<void>(),
    loading: true
};
